export enum PROJECT_SHARE_TYPE {
  ANYONE = 'anyone',
  ONLY_MEMBERS = 'only_members',
  PASSWORD = 'password',
}

export enum PROJECT_LINK_PERMISSION_TYPE {
  VIEW = 'view',
  COMMENT = 'comment',
  EDIT = 'edit',
}

export enum PROJECT_MEMBER_LINK_PERMISSION_TYPE {
  VIEW = 'view',
  COMMENT = 'comment',
  EDIT_CONTENT = 'edit_content',
  EDIT = 'edit',
}
